import { AccountStatus, PersonType, Currency } from 'enums';

export const getInitialValues = (personType: PersonType): Partial<AccountEditBasic> => ({
  title: '',
  currency: Currency.NONE,
  email: '',
  phone: '',

  client: {
    personType: PersonType.NONE,
    companyName: '',
    birthDate: '',
    firstname: '',
    gender: personType === PersonType.PHYSICAL ? '' : undefined,
    lastname: '',
    retired: false,
    fixedTax: false,
    taxResidency: { country: '' },
  },
});

export interface ClientBasic {
  personType: PersonType;
  firstname: string;
  lastname: string;
  gender?: string;
  birthDate: string;
  retired: boolean;
  fixedTax: boolean;
  companyName: string;
  options?: {
    taxResidencyCountry: string[];
  };
  taxResidency: {
    country: string;
  };
}

export enum AccountClientSelectable {
  UNLIMITED = 'UNLIMITED',
  UNAVAILABLE = 'UNAVAILABLE',
  WARN = 'WARN',
  WARN_REP = 'WARN_REP',
}

export interface AccountEditBasic {
  accountId?: string;
  accountStatus: AccountStatus;
  accountProcessing: boolean;
  client: ClientBasic;
  title: string;
  currency: Currency;
  email: string;
  phone: string;
  readOnly: boolean;
  selectable: AccountClientSelectable;

  options: {
    currency: Currency[];
    gender: string[];
  };
}

export interface AccountBasic {
  client: { firstname: string; retired: boolean; personType: PersonType; taxResidency: string };
  currency: Currency;
}
